module.exports = __webpack_public_path__ + "static/media/goodfood.fdb3c40b.svg";